<template>
   <div
      :class="{
        beforeStickyNavbar: scrollPosition < 0,
        stickyNavbar: scrollPosition > 0.5,
      }"
    >
      <div class="container-sm">
        <div
          class="case-status"
          v-if="this.getSendOutInformation && this.getSendOutInformation.status"
        >
          <ul class="justify-content-between" style="width:100%">
            <li>
              <ul>
                <li>
                  <h3 class="name">SendOut Status</h3>
                </li>
                <li>
                  <el-button type="success" size="medium" class="px-010 cursor-test"
                    :class="this.getSendOutInformation.status">
                    <span class="pr-5" v-if="this.getSendOutInformation.status === 'COMPLETE'">FINALIZED</span>
                    <span class="pr-5" v-else>{{
                      this.getSendOutInformation.status.split("_").join(" ")
                    }}</span>
                  </el-button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  <section class="new-case-view case-creation scrollHeight" v-loading="loading">
    <div class="case-view-body">
      <div class="container-sm">
        <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img src="@/assets/images/icons/icon-patient-info.svg" alt="icon" class="img-fluid" />
              </span>
              <h3 class="title">Patient Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-data" v-if="
              getSendOutInformation &&
              Object.keys(getSendOutInformation).length > 0
            ">
              <el-row :gutter="20">
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">First Name</h4>
                    <p class="value" v-if="getSendOutInformation.patient_info.first_name">
                      {{
                        convertToUppercase(
                          getSendOutInformation.patient_info.first_name
                        )
                      }}
                    </p>
                    <p class="value" v-else>--</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Middle Name</h4>
                    <p class="value">
                      {{
                        convertToUppercase(
                          getSendOutInformation.patient_info.middle_name) || "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases" v-if="
                    getSendOutInformation.patient_info &&
                    getSendOutInformation.patient_info.last_name
                  ">
                    <h4 class="name">Last Name</h4>
                    <p class="value">
                      {{
                        convertToUppercase(
                          getSendOutInformation.patient_info.last_name
                        )
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Gender</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.gender }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Date of Birth</h4>
                    <p class="value">
                      {{
                        formatDate(
                          getSendOutInformation.patient_info.date_of_birth
                        )
                      }}
                    </p>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">EMR #</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.emr || "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Mobile Number</h4>
                    <p class="value">
                      {{
                        getSendOutInformation.patient_info.home_phone || "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Phone Number</h4>
                    <p class="value">
                      {{
                        getSendOutInformation.patient_info.work_phone || "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Email</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.email || "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 1</h4>
                    <p class="value">
                      {{
                        getSendOutInformation.patient_info.address_line_1 ||
                        "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 2</h4>
                    <p class="value">
                      {{
                        getSendOutInformation.patient_info.address_line_2 ||
                        "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Zip</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.zip }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" v-if="!isBillingUser" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Zip Extension</h4>
                    <p class="value">
                      {{ getSendOutInformation?.patient_info?.zip_extension || "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">State</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.state }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">City</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.city }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Race</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.race || "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Ethnicity</h4>
                    <p class="value">
                      {{ getSendOutInformation.patient_info.ethnicity || "--" }}
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <span class="case-creation__divider"></span>

        <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img src="@/assets/images/icons/icon-case-info.svg" alt="icon" class="img-fluid" />
              </span>
              <h3 class="title">Case Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0" v-if="
            getSendOutInformation &&
            Object.keys(getSendOutInformation).length > 0
          ">
            <el-row :gutter="15">
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases" v-if="
                  getSendOutInformation && getSendOutInformation.case_types
                ">
                  <h4 class="name">Case Type</h4>
                  <ul>
                    <li v-for="(
                        caseType, index
                      ) of getSendOutInformation.case_types" :key="index">
                      {{ caseTypeMap[caseType] }}
                    </li>
                  </ul>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Received Laboratory</h4>
                  <p class="value" v-if="getSendOutInformation?.received_lab">
                    {{ getSendOutInformation.received_lab.replace(/_/g, " ").replace(/MEDICAL GROUP/gi, "TESTGO") }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Collection Date</h4>
                  <p class="value">
                    {{
                      momentWithTimezoneTime(
                        getSendOutInformation.collection_date,
                        "MM-DD-yyyy hh:mm A",
                        getSendOutInformation?.timezone
                      )
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Received Date</h4>
                  <p class="value">
                    {{
                      momentWithTimezoneTime(
                        getSendOutInformation.received_date,
                        "MM-DD-yyyy hh:mm A",
                        getSendOutInformation?.timezone
                      )
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Ordering Facility</h4>
                  <p class="value" v-if="getSendOutInformation.hospital">
                    {{ getSendOutInformation.hospital.name }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Ordering Physician</h4>
                  <p class="value" v-if="getSendOutInformation.ordering_physician">
                    {{ getSendOutInformation.ordering_physician.first_name  + ' ' +  getSendOutInformation.ordering_physician.last_name }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Accession ID</h4>
                  <p class="value" v-if="getSendOutInformation.accession_id">
                    {{ getSendOutInformation.accession_id }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Bill To</h4>
                  <p class="value" v-if="getSendOutInformation.billing_type">
                    {{ getSendOutInformation.billing_type }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="12" :lg="12" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases icd-codes">
                  <div class="indicatives">
                    <h4 class="name">ICD-10 (Indicative)</h4>
                    <ul>
                      <li class="value" v-for="(
                          icd_10_code, index
                        ) in getSendOutInformation.icd_10_codes" :key="index">
                        {{ icd_10_code }}
                      </li>
                    </ul>
                  </div>
                </div>
              </el-col>
              <!-- <el-col :xl="6" :lg="8" :md="8" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <div class="speciment-type-view" v-if="
                    getSendOutInformation &&
                    getSendOutInformation.sample_types
                  ">
                    <div>
                      <h4 class="name">Specimen Types</h4>
                      <ul class="case_type" v-if="
                        getSendOutInformation.sample_types &&
                        getSendOutInformation.sample_types.length
                      ">
                        <li class="value" v-for="(
                            sampleType, index
                          ) in getSendOutInformation.sample_types" :key="index">
                          {{ caseTypeMap[sampleType.case_type] }}
                        </li>
                      </ul>
                      <ul v-else>
                        --
                      </ul>
                    </div>
                    <div>
                      <h4 class="name">&nbsp;</h4>
                      <ul class="speciment_type" v-if="
                        getSendOutInformation.sample_types &&
                        getSendOutInformation.sample_types.length
                      ">
                        <li v-for="(
                            sampleType, index
                          ) in getSendOutInformation.sample_types" :key="index">
                          <span v-if="
                            sampleType.sample_types &&
                            sampleType.sample_types.length
                          ">
                            <span v-for="(sample, index) in sampleType.sample_types" :key="index">
                              {{ sample }}
                              <span v-if="
                                index + 1 < sampleType.sample_types.length
                              ">,</span>
                            </span>
                          </span>
                          <span v-else> -- </span>
                        </li>
                      </ul>
                      <ul v-else>
                        --
                      </ul>
                    </div>
                  </div>
                </div>
              </el-col> -->
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12" v-if="hadClinicalChemistry">
                <div class="input-value view-cases">
                  <h4 class="name">Fasting</h4>
                  <p class="value">
                    {{ getSendOutInformation.is_fasting ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <span class="case-creation__divider"></span>
        <div class="case-creation__card">
        <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Order Codes</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <el-row :gutter="15">
              <el-col
                :xl="3"
                :lg="4"
                :md="8"
                :sm="12"
                :xs="12"
              >
                <div class="input-value view-cases">
                  <p
                    class="value"
                    style="
                      background: #bf1b39;
                      width: 180px;
                      height: 18px;
                      border-radius: 10px;
                      padding-left: 14px;
                      color: white;
                    "
                  >
                    <span v-if="getSendOutInformation && getSendOutInformation.testgo_order_codes">
                      {{ getSendOutInformation.testgo_order_codes.join(', ') }}
                    </span>
                  </p>
                </div>
              </el-col>
              </el-row>
          </div>
          </div>
            <span class="case-creation__divider"></span>
        <div> 
          <Medication></Medication>
        </div> 
         <span class="case-creation__divider"></span> 
         <div>
          <BillingInfo></BillingInfo>
         </div>
        <span class="case-creation__divider"></span>
        <TestReport v-if="showReports"></TestReport>
        <span class="case-creation__divider"></span>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseConstants from "@/config/constants/caseConstants"; 
import BillingInfo from "@/components/sendOuts/BillingInfo";
const Medication = defineAsyncComponent(() =>
  import("@/components/sendOuts/MedicationsView")
);
const TestReport = defineAsyncComponent(() =>
  import("@/components/sendOuts/TestReports")
);
export default {
  mixins: [UserPermissionsHelper],
  components: {
    Medication,
    TestReport,
    BillingInfo,
  },
  computed: {
    ...mapGetters("sendOuts", ["getSendOutInformation", "getShowMedication"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("labTests", ["getAllLabTests", "getNewLabGroupWiseTests", "getNewLabGroupWiseTestsData"]),
    isCaseCompleted() {
      if (!this.getSendOutInformation) {
        return false;
      }
      return this.getSendOutInformation.status === "COMPLETE";
    },
    sendOutId() {
      if (this.$route.params && this.$route.params.sendout_id) {
        return this.$route.params.sendout_id;
      }
      return null;
    },
    hadClinicalChemistry() {
      if (
        this.getSendOutInformation &&
        this.getSendOutInformation.case_types &&
        this.getSendOutInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
      ) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      scrollPosition: null,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseInfo: {},
      showReports: false,
      loading: false,
    };
  },
  mounted() {
      this.checkSendoutInfomaton();
    this.caseInfo = JSON.parse(JSON.stringify(this.getSendOutInformation));
    // Add Class
    this.toggleBodyClass("addClass", "fixedNavbarBody");
    // Scroll
    window.addEventListener("scroll", this.updateScroll);
  },
  async unmounted() {
    // Remove Class
    this.toggleBodyClass("removeClass", "fixedNavbarBody");
  },
  methods: {
    async checkSendoutInfomaton() {
      try {
        this.loading = true;
        this.showReports = false;
        await this.$store.dispatch("sendOuts/fetchSendOutInformation", {
          send_out_id: this.sendOutId,
        });

        setTimeout(() => {
          this.showReports = true;
        }, 100);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    async toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.test-reports-not-available {
  text-align: center;
  padding: 1rem 0;
  color: #f24a65;
  font-weight: 500;
}

.icd-codes {
  .indicatives {
    ul {
      display: flex;

      li {
        margin: 0 6px;

        p {
          .value {
            padding: 3px 12px !important;
          }
        }
      }
    }
  }
}
.case-status {
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  justify-content: end;
  li {
    button {
      cursor: default;
    }
  }
}
</style>
